<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ this.$store.getters.isAdmin ? $t('Clients') : $t('Collaborators') }}</h1>
          <h2 class="page-subtitle">{{ $t('Total') }} : {{ totalCount }}</h2>
        </div>
        <b-button v-if="allowCreate" variant="primary" @click="clickOnCreateBtn">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a') }} {{ this.$store.getters.isAdmin ? $t('client') : $t('collaborator') }}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableUser"
          :editItem=allowEdit
          :empty-button="$t('collaborator.emptyButton').toString()"
          :empty-text="$t('collaborator.emptyText').toString()"
          :empty-title="$t('collaborator.emptyTitle').toString()"
          :fields="tableFields"
          get-b122-table-results-url="/user/getB122TableResults"
          identifier="B122TableUser"
          init-b122-table-url="/user/initB122Table"
          @add="clickOnCreateBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnShowBtn="clickOnShowBtn"
          @setTotalCount="setTotalCount">

          <template #cell(role)="row">
            <div>{{ $t(row.item.role) }}</div>
          </template>

        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :itemSingularName="this.$store.getters.isAdmin? 'client': 'collaborator'"
      :selectedItem="ui.selectedUser"
      :selectedItemSpecialString="ui.selectedUser ? ui.selectedUser.username : null"
      controllerName="user"
      itemSingularNameUpp="User"
      @didDeleteItem="didDeleteUser()">
    </Item-delete-modal>

  </div>
</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'
import api from "../../services/api";

export default {

  name: 'UserIndex',

  components: {
    B122Table,
    ItemDeleteModal
  },

  data() {
    return {

      totalCount: 0,
      allowCreate: true,
      allowDelete: true,
      allowEdit: true,
      isCollaborator: this.$store.getters.isCollaborator,
      isCollaboratorPlus: this.$store.getters.isCollaboratorPlus,
      ui: {
        selectedUser: null
      }

    }
  },

  computed: {

    tableFields() {
      return [
        {
          label: this.$i18n.t('Show'),
          key: 'show',
          sortable: false
        },
        {
          label: this.$i18n.t('user.Firstname'),
          key: 'firstname',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Lastname'),
          key: 'lastname',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Username'),
          key: 'username',
          sortable: true
        },
        {
          label: this.$i18n.t('user.PhoneNumber'),
          key: 'phoneNumber',
          sortable: false
        },
        {
          label: this.$i18n.t('role.enum.type.collaborator'),
          key: 'role',
          sortable: false
        },
        {
          label: '',
          key: 'actions'
        }
      ]
    }

  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    async showPopup() {
      this.$bvModal.msgBoxConfirm(
        this.$i18n.t('premium.no.more.user').toString(),
        {
          okTitle: this.$i18n.t('SeeSubscription'),
          cancelTitle: this.$i18n.t('Cancel'),
          centered: true,
          okVariant: 'primary',
          cancelVariant: 'secondary',
        }
      ).then((confirmed) => {
        if (confirmed) {
          this.$router.push({ name: 'ProfileShow' });
        }
      });
    },

    async checkIfCanCreateNewUser() {
      try {
        const response = await api.get(`/user/checkIfCanCreateNewUser`);
        return response.data.canCreate;
      } catch (error) {
        return false;
      }
    },

    async clickOnCreateBtn() {
      if (this.$store.getters.isAdmin) {
        this.$router.push({
          name: 'UserCreate'
        })
      } else {
        const canCreate = await this.checkIfCanCreateNewUser();
        if (canCreate) {
          this.$router.push({
            name: 'UserCreate'
          })
        } else {
          await this.showPopup()
        }
      }
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'UserShow',
        params: {
          userId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'UserEdit',
        params: {
          userId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedUser = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteUser() {
      this.ui.selectedUser = null
      this.$refs.B122TableUser.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserIndex.vue